<template>
    <div>
        <div class="login-main">
<!--            <el-card class="box-card">-->
<!--                <div slot="header" class="clearfix">-->
<!--                    <span>密码登录</span>-->

<!--                </div>-->
<!--                <el-input-->
<!--                        placeholder="请输入账号"-->
<!--                        prefix-icon="el-icon-user"-->
<!--                        v-model="username"-->
<!--                        clearable key="username">-->
<!--                </el-input>-->
<!--                <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="password" show-password key="password"></el-input>-->
<!--                <el-button style=" padding: 3px 0" type="text" @click="submitForm()">登录</el-button>-->
<!--            </el-card>-->
            <loginform></loginform>

        </div>
    </div>
</template>

<script>
    import Loginform from "../loginform/Loginform";
    export default {
        name: "LoginP",
        components:{
            Loginform,
        },
        data() {
            return {
                username: '1222',
                password:'',
            }
        },
        methods: {
            submitForm() {
                alert(this.username)
            },
        }

    }
</script>

<style scoped>
.login-main{
    position: relative;
    left: 35%;
    width: 30%;
}
</style>